import { render, staticRenderFns } from "./AbsenceRequestCalendar.vue?vue&type=template&id=2f564c8c&"
import script from "./AbsenceRequestCalendar.vue?vue&type=script&lang=js&"
export * from "./AbsenceRequestCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports